function localDate(date: string): Date {
  const [year, month, day] = date.split('-').map(Number)
  return new Date(year, month - 1, day)
}

export function formatDate(
  date: string,
  options: Intl.DateTimeFormatOptions = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' },
  locale = 'en',
): string {
  return localDate(date).toLocaleDateString(locale, options)
}

export function formatDateShort(date: string, locale = 'en'): string {
  return formatDate(date, { day: 'numeric', month: 'short', year: 'numeric' }, locale)
}

export function formatTime(value: string): string {
  if (!/^\d{1,2}:\d{2}$/.test(value)) return value
  const [hours, minutes] = value.split(':').map(Number)
  const period = hours >= 12 ? 'pm' : 'am'
  const hour = hours % 12 || 12
  return minutes === 0 ? `${hour}${period}` : `${hour}:${String(minutes).padStart(2, '0')}${period}`
}

export function formatCurrency(value: number | null | undefined, currency = '', locale = 'en', exact = false): string {
  if (value == null || !Number.isFinite(value)) return '—'
  const currencyDigits = currency ? new Intl.NumberFormat(locale, { style: 'currency', currency }).resolvedOptions().maximumFractionDigits : 2
  const digits = exact || !Number.isInteger(value) ? currencyDigits : 0
  return new Intl.NumberFormat(locale, {
    ...(currency ? { style: 'currency', currency } : {}),
    minimumFractionDigits: digits, maximumFractionDigits: digits,
  }).format(value)
}
